import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface DeclineAccessRequestDialogData {
    name: string;
    surname: string;
}

export interface DeclineAccessRequestDialogResult {
    reason: string;
}

@Component({
    selector: 'app-decline-access-request-dialog',
    templateUrl: './decline-access-request-dialog.component.html',
    styleUrls: ['./decline-access-request-dialog.component.scss']
})
export class DeclineAccessRequestDialogComponent {
    form: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<DeclineAccessRequestDialogComponent, DeclineAccessRequestDialogResult>,
        @Inject(MAT_DIALOG_DATA) public data: DeclineAccessRequestDialogData,
        private fb: FormBuilder
    ) {
        this.form = this.fb.group({
            reason: ['', [Validators.required, Validators.maxLength(300)]]
        });
    }

    get requesterName(): string {
        return `${this.data.name} ${this.data.surname}`.trim() || 'this request';
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onDecline(): void {
        const reasonControl = this.form.get('reason');
        const reason = String(reasonControl?.value ?? '').trim();

        if (!reason) {
            reasonControl?.setErrors({ required: true });
        }

        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }

        this.dialogRef.close({
            reason
        });
    }
}
